export default __webpack_public_path__ + "static/media/copy.d789c761.svg";